import React from 'react'
import { useInfiniteHits } from 'react-instantsearch'
import { default as BlogArticleListingGallery } from '@interflora/ui-components/build/components/BlogArticleListing/BlogArticleListing'
import { algoliaBlogArticleMapping } from '@interflora/ui-components/build/utils/common'
import { AlgoliaBlogLatestArticles } from '@interflora/ui-components/build/common/props'
import { useRouter } from 'next/router'

const ListingWrapper = () => {
  const router = useRouter()
  const hits = useInfiniteHits<AlgoliaBlogLatestArticles>()
  const items = algoliaBlogArticleMapping(hits.items)
  return <BlogArticleListingGallery items={items} key={router?.query?.page?.toString()} />
}

export default ListingWrapper
